import React, { useState } from 'react';
import {
  Button,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  LargeHeader,
  Layout,
  LayoutItem,
} from '@axiom/ui';

import { useUserAccountData } from '../../hooks/useUserAccountData';
import { EngagementsShareModal } from '../EngagementsShareModal/EngagementsShareModal';
import { EngagementsShareContextMenu } from '../EngagementsShareContextMenu/EngagementsShareContextMenu';
import { useEngagementTalentData } from '../../hooks/useEngagementTalentData';
import { EngagementHelpModal } from '../EngagementHelpModal/EngagementHelpModal';
import { SubmissionApi } from '../../api/submission-api';
import { LinkUtil } from '../../utils/link-util';

export const EngagementHeader = () => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const { account, user } = useUserAccountData();
  const { accountId, submission, invalidSubmissionRequest } =
    useEngagementTalentData({ account });

  return invalidSubmissionRequest || !accountId || !submission ? null : (
    <>
      <Grid stackable name="CLIENT_ACTIONS_BANNER">
        <GridRow gutterBottom="16px">
          <GridColumn width={12}>
            <Button
              to="../../engagements"
              name="BACK_TO_ENGAGEMENTS"
              pattern="primary"
              variation="minimal"
              icon="arrow-left"
              iconPosition="left"
              onClick={async () => {
                return SubmissionApi.refreshSubmissionDetails(
                  submission.submissionId
                );
              }}
            >
              All Engagements
            </Button>
            <Gutter bottom="8px" only="mobile" />
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn largeScreenWidth={8} tabletWidth={6} mobileWidth={12}>
            <LargeHeader>{submission.jobName}</LargeHeader>
            <Gutter bottom="16px" only="mobile" />
          </GridColumn>
          <GridColumn
            largeScreenWidth={4}
            tabletWidth={6}
            mobileWidth={12}
            verticalAlign="bottom"
            textAlign="right"
          >
            <Layout
              direction="horizontal"
              position="right"
              stackableOn="mobile"
            >
              <LayoutItem>
                <EngagementsShareContextMenu
                  currentSubmission={submission}
                  user={user}
                  onClickInviteToAccount={() => {
                    setShowShareModal(!showShareModal);
                  }}
                  onClickOpenInAhq={() => {
                    window.open(LinkUtil.generateAHQOpportunityURL(submission));
                  }}
                />
                <Gutter bottom="8px" only="mobile" />
              </LayoutItem>
              {submission.selfService ? (
                <>
                  <Gutter right="24px" only="tablet largeScreen" />
                  <LayoutItem>
                    <Button
                      fluid
                      name="need-help-button"
                      pattern="primary"
                      variation="outline"
                      onClick={() => {
                        setShowHelpModal(true);
                      }}
                    >
                      Need Help?
                    </Button>
                  </LayoutItem>
                </>
              ) : null}
            </Layout>
          </GridColumn>
        </GridRow>
      </Grid>
      {!!showShareModal && (
        <EngagementsShareModal
          accountName={account.calculatedName}
          accountId={accountId}
          currentSubmission={submission}
          onClose={() => {
            setShowShareModal(!showShareModal);
          }}
        />
      )}
      {showHelpModal ? (
        <EngagementHelpModal
          onClose={() => {
            setShowHelpModal(false);
          }}
          currentSubmission={submission}
        />
      ) : null}
    </>
  );
};
